import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { AssetDataWindowPage } from "@/modules/asset_data/WindowPage";
import { AssetDataHistoryPage } from "@/modules/asset_data/HistoryPage";

/** Asset Data — decoded telemetry Orbit is receiving now, live and historic.
 *
 *  `base` MUST match the route App.tsx mounts this module on (/asset-data).
 *  It said "/live" from the 2026-09-22 rename until 2026-09-23: the rail entry
 *  and the App route both moved, the SubNav base did not, so every tab linked
 *  to /live/<tab>, matched nothing, and fell through to the catch-all redirect
 *  home. Overview appeared to work only because the module's own relative
 *  path="*" redirect lands on /asset-data/overview without going via `base`.
 *
 *  TWO SUBPAGES, BOTH ABOUT ONE ASSET. Live Window and History are keyed on
 *  an `imei`; that is what this module is for. Overview was a FLEET view — a
 *  map of many devices, a company picker, a fleet-wide firmware donut — and it
 *  moved to `/fleet/overview` on 2026-10-23 at Dattatray's request. The old
 *  path REDIRECTS rather than 404s: the SPA catch-all answers an unknown path
 *  with index.html, so a dead bookmark renders a blank page, which is the
 *  worse failure.
 *
 *  ASSET CONTROL IS NOT HERE EITHER, for the same reason one layer up (D-111):
 *  its gate is GATE_FLEET while this module's is GATE_ASSET_DATA, so it was a
 *  tab some users could see and not use. App.tsx redirects that path.
 *
 *  NOTE ON GATES, since the move crosses one: GATE_ASSET_DATA is in every
 *  plan; GATE_FLEET is in every plan EXCEPT a BASIC `company_user`. So a Basic
 *  user loses the fleet overview. Measured on the box before moving it: there
 *  are no Basic accounts at all today (3 pro_plus admins, 1 pro_plus user, 3
 *  super_admins), so this costs nobody now and becomes real the day a Basic
 *  customer is onboarded — at which point the fix is one line in
 *  `plans.py:_USER_BASIC`. Deliberately not done now; the plan structure is a
 *  separate decision Dattatray has deferred. */
export function AssetDataModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav
          base="/asset-data"
          tabs={[
            { path: "window", label: "Live Window" },
            { path: "history", label: "History" },
          ]}
        />
        <div style={{ marginLeft: "auto", paddingBottom: 9, paddingRight: 20 }}>
        </div>
      </div>
      <Routes>
        {/* GONE TO FLEET, redirected not dropped. */}
        <Route path="overview" element={<Navigate to="/fleet/overview" replace />} />
        <Route path="window" element={<AssetDataWindowPage />} />
        <Route path="history" element={<AssetDataHistoryPage />} />
        <Route path="*" element={<Navigate to="window" replace />} />
      </Routes>
    </>
  );
}
